import React from 'react';
import PropTypes from 'prop-types';

import DefaultImage from 'pages/MyAccount/shared-components/DefaultImage/DefaultImage';
import defaultImage from '../../Product/default-image.png';
import { ReactComponent as SurpriseMeIcon } from '../../Product/surprise-me-icon.svg';
import styles from './styles.module.scss';

const ItemImage = ({ brandName, name, imageUrl, autoAssigned, slug }) => {
  const productName = brandName ? `${brandName} ${name}` : name;
  const productUrl = `/product/${slug}`;

  return (
    <li className={styles.item}>
      {autoAssigned ? (
        <SurpriseMeIcon className={styles.surprise} />
        ) : (
          <a href={productUrl} target="_blank" rel="noreferrer">
            <figure>
              <DefaultImage src={imageUrl} defaultImage={defaultImage} alt={productName} />
            </figure>
          </a>
        )}
    </li>
  );
};

ItemImage.propTypes = {
  brandName: PropTypes.string,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  autoAssigned: PropTypes.bool.isRequired,
  slug: PropTypes.string.isRequired,
};

ItemImage.defaultProps = {
  brandName: null,
};

export default ItemImage;
